"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _core = require("@linaria/core");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _text = _interopRequireDefault(require("@ux/text"));
var _groupToggleItem = _interopRequireDefault(require("./group-toggle-item"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Local Imports
 */

const RootContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "RootContainer",
  class: "pl-rvdhlpr"
});
const SwitchContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SwitchContainer",
  class: "pl-snm6ikd"
});
const Notch = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Notch",
  class: "pl-n1rv3gr5"
});
const SwitchWrapper = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "SwitchWrapper",
  class: "pl-s4iaquh",
  vars: {
    "s4iaquh-6": [({
      qty
    }) => qty],
    "s4iaquh-10": [({
      qty,
      activeIdx
    }) => `calc(100%/${qty}*${activeIdx})`]
  }
});
const message = "pl-m1wnqy1";

/**
 * GroupToggle Component.
 *
 * @param {Object} props React props
 * @param {String} props.id Unique id of the component
 * @param {Array} props.groups Group content item
 * @param {String} props.activeGroupIdx Index of active group
 * @param {String} props.toggleMessage Text under the toggle
 * @param {Function} props.changeHandler onChange Handler
 * @returns {React.ReactElement} GroupToggle Component
 * @public
 */

function GroupToggle({
  id,
  groups,
  activeGroupIdx,
  changeHandler,
  ...rest
}) {
  (0, _react.useEffect)(() => {
    const selected = document.querySelector(`:focus + label`);
    selected?.scrollIntoView({
      block: 'nearest',
      inline: 'center'
    });
  }, [activeGroupIdx]);
  return /*#__PURE__*/_react.default.createElement(RootContainer, rest, groups?.length > 1 && /*#__PURE__*/_react.default.createElement(SwitchContainer, {
    "data-cy": "group-toggle"
  }, /*#__PURE__*/_react.default.createElement(SwitchWrapper, {
    role: "radiogroup",
    qty: groups.length,
    activeIdx: activeGroupIdx
  }, groups.map((group, idx) => /*#__PURE__*/_react.default.createElement(_groupToggleItem.default, (0, _extends2.default)({
    key: idx,
    id: `group${idx}-${id}`,
    name: `group-${id}`,
    _name: `switch-toggle-${idx}`,
    value: idx,
    onChange: changeHandler,
    isSelected: activeGroupIdx === idx,
    dataCy: `group-toggle-item-${idx}`
  }, group))), /*#__PURE__*/_react.default.createElement(Notch, {
    "data-cy": "notch"
  }))), groups[activeGroupIdx]?.groupMessage && /*#__PURE__*/_react.default.createElement(_text.default.p, {
    as: "paragraph",
    size: 1,
    text: groups[activeGroupIdx].groupMessage,
    className: message,
    "data-cy": "group-message"
  }));
}
var _default = exports.default = GroupToggle;
GroupToggle.propTypes = {
  id: _propTypes.default.string,
  groups: _propTypes.default.arrayOf(_propTypes.default.object),
  activeGroupIdx: _propTypes.default.number,
  changeHandler: _propTypes.default.func,
  toggleMessage: _propTypes.default.string
};